import { Edge, NodeProps, Node } from "reactflow"
import { Edge as AbsenceEdge } from "../../../../../@client/Theasoft_Absences_Workflow"
import { AbsentApprovalNode } from "../../../../../@client/Absents"
import { Guid } from "../../../../../@client/System"
import { AbsentApprovalConfigNodeDetails } from "../../../../../@client/Theasoft_Absences_Config"

export type ApprovalConfigNodeProps = NodeProps<AbsentApprovalConfigNodeDetails>

export type ApprovalConfigNode = Node<AbsentApprovalConfigNodeDetails>

type NodeType = "trigger" | "approval" | "condition"

type Data = AbsentApprovalNode & { isActive: boolean }

export type AbsentApprovalNodeType = Node<Data, NodeType>

export type ApprovalNodeProps = NodeProps<Data>

export function toFlowEdge(edge: Edge): Edge {
  return {
    id: edge.id,
    source: edge.source,
    target: edge.target,
    type: "custom",
  }
}

export function toTsEdge(edge: Edge): AbsenceEdge {
  return {
    id: edge.id as Guid,
    source: edge.source as Guid,
    target: edge.target as Guid,
  }
}
